import { render, staticRenderFns } from "./LogoutNotification.vue?vue&type=template&id=1a8678a5&"
import script from "./LogoutNotification.vue?vue&type=script&lang=js&"
export * from "./LogoutNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports